module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Fireplace-63cbf63ae441f900c1388e468d21405f.svg";